<template>
  <v-card>
    <v-card-title primary-title>
      Bekräfta preskribering
    </v-card-title>

    <v-card-subtitle primary-title> UUID: {{ uuid }} </v-card-subtitle>

    <v-card-text>
      Är du säker på att du vill ta bort upphittat föremål?
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="onClose" :loading="destructLoading">
        Avbryt
      </v-btn>
      <v-btn
        type="submit"
        color="error"
        text
        @click="onConfirm"
        :loading="destructLoading"
      >
        Ta bort
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DESTRUCT_LOST_PROPERTY from '@/gql/lostProperties/mutations/DestructLostProperty.gql'

export default {
  name: 'LostPropertiesDestructConfirm',

  props: {
    uuid: String,
  },

  data() {
    return {
      destructLoading: false,
    }
  },

  methods: {
    onClose() {
      this.$emit('close')
    },

    async onConfirm() {
      this.destructLoading = true
      await this.destructLostProperty()
      this.$router.push(`/${this.owner}/lost-properties`)
    },

    destructLostProperty() {
      return this.$apollo.mutate({
        mutation: DESTRUCT_LOST_PROPERTY,
        variables: {
          uuid: this.uuid,
        },
      })
    },
  },
}
</script>
